<template>
  <BaseLayout>
    <div class="registeredFulfill">
      <img class="RegisteredLogoedImage m-b-50" src="./assets/registered-logo-ed.png" />
      <div class="title">恭喜您,注册成功</div>
      <!-- <div class="title-samll m-b-40">（当前仅支持Pad端）</div>
      <div class="f-center label">
        打开应用商店或App store搜索"
        <div class="primary-font">律小购</div>"即可下载
      </div>-->

      <div  class="f-column">
      <!-- <div v-if="route.query.userType == 'individual'" class="f-column"> -->
        <div class="label f-center">扫描二维码下载律小购APP</div>
        <div class="f-between p-l-45 p-r-45 m-t-150">
        
          <div class="f-center f-column">
            <div class="appQRcode-box m-b-10">
              <div class="subscripx"></div>
              <img class="appQRcodeAndroidImage" :src="androidQRcode" />
            </div>
            <div class="label-black m-b-15">扫一扫下载</div>
            <div class="text-center label-black">Android客户端</div>
          </div>
        </div>
      </div>
      <!-- <div v-else class="f-column f-center">
        <div class="label">扫描二维码下载律小购律所端APP(ipad)</div>
        <div class="f-center f-column m-t-150">
          <div class="appQRcode-box m-b-10">
            <img class="appQRcodeIosImage" src="../../assets/lg-ipad-code.png" />
          </div>
          <div class="label-black m-b-15">扫一扫下载</div>
          <div class="text-center label-black">ipad律小购律所端</div>
        </div>
      </div> -->
    </div>
  </BaseLayout>
</template>

<script>
import { useRoute } from 'vue-router'
import QRcode from 'jr-qrcode'
import { ref, onMounted, computed } from 'vue'
import { versionApi } from '@/apis'

document.getElementsByTagName('title')[0].innerText = '注册成功'
export default {
  setup() {
    const androidQRcode = ref('')

    // Fallback URL（环境变量）
    const fallbackUrl = process.env.VUE_APP_FILE_URL + '/app-release.apk'
    androidQRcode.value = QRcode.getQrBase64(fallbackUrl)

    // 获取最新 APK URL
    onMounted(async () => {
      try {
        const data = await versionApi.currentNew('C-side-android')
        if (data?.bridgeUrl) {
          androidQRcode.value = QRcode.getQrBase64(data.bridgeUrl)
        }
      } catch (e) {
        console.error('获取版本失败:', e)
        // 失败保持 fallback
      }
    })

    const route = useRoute()

    return { route, androidQRcode }
  },
}
</script>
<style lang="scss">
@import './utils.scss';
.registeredFulfill {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 120px;
  background: linear-gradient(0deg, #f5f8ff 0%, #ffffff 100%);
  .RegisteredLogoedImage {
    width: 115px;
    height: 113px;
  }
  .primary-font {
    color: #2c55ed;
  }
  .RegisteredLogoImage {
    width: 94px;
    height: 112px;
    margin-bottom: 50px;
  }
  .title {
    font-size: 34px;
    margin-bottom: 144px;
    color: #333;
  }
  .title-samll {
    font-size: 32px;
    color: #333;
  }
  .label {
    font-size: 28px;
  }
  .label-black {
    font-size: 28px;
    color: #1f2329;
  }
  .appQRcode-box {
    position: relative;
    // padding: 20px;
    background-color: #fff;
    overflow: hidden;
    .appQRcodeIosImage {
      width: 192px;
      height: 192px;
    }
    .appQRcodeAndroidImage {
      width: 192px;
      height: 192px;
    }
  }
}
</style>